import type { PageSelection } from '../../services/faxDocuments';

/**
 * One page on the board.
 *
 * `key` is a value of its own rather than `${source}-${page}`, because the same
 * source page can legitimately appear twice — a cover page kept in both halves
 * of a split — and two items sharing a drag id would make them swap places or
 * vanish.
 */
export interface BoardPage extends PageSelection {
  key: string;
}

export interface PageBoardSource {
  /** Where the bytes are. A short-lived signed URL. */
  url: string;
  /** Pages this source has, once its PDF has been read. */
  pageCount: number | null;
}

let nextKey = 0;

export function boardKey(): string {
  nextKey += 1;
  return `page-${nextKey}`;
}

/** Every page of every source, in order, as a starting board. */
export function allPagesOf(sources: PageBoardSource[]): BoardPage[] {
  return sources.flatMap((source, index) =>
    Array.from({ length: source.pageCount ?? 0 }, (_unused, offset) => ({
      source: index,
      page: offset + 1,
      rotation: 0,
      key: boardKey(),
    }))
  );
}
